import styled from "styled-components";
import { isMobile } from "../../../common/utils";

export const StyledLoginEmailPin = styled('div')`
  color: var(--allie-color-neutral-70);
  ${isMobile ? 'text-align-last: center;' : ''}
`;
